import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import NotificationPreferences from "@/components/NotificationPreferences";

export default function PushSubscribeButton() {
  const [supported, setSupported] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ok = "serviceWorker" in navigator && "PushManager" in window;
    setSupported(ok);
    if (!ok) return;
    navigator.serviceWorker.ready.then(async (reg) => {
      const sub = await reg.pushManager.getSubscription();
      setSubscribed(!!sub);
    });
  }, [open]);

  if (!supported) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="push-subscribe-btn"
        className="p-2 hover:opacity-70 transition relative"
        aria-label={subscribed ? "Preferencias de notificaciones" : "Activar notificaciones"}
        title={subscribed ? "Preferencias de notificaciones" : "Activar notificaciones"}
        style={{ color: subscribed ? "var(--accent)" : "var(--text)" }}
      >
        <span className={subscribed ? "" : "mobile-bell-blink"} style={{ display: "inline-block" }}>
          <Bell size={18} strokeWidth={2.2} fill={subscribed ? "currentColor" : "none"} />
        </span>
        {!subscribed && (
          <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-500">
            <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-75" />
          </span>
        )}
      </button>
      {open && <NotificationPreferences onClose={() => setOpen(false)} />}
    </>
  );
}
